import React from 'react';

/**
 * QuoteBlock — blockquote with right-aligned attribution
 *
 * Props:
 *  quote         string   — the quote text (without quotes, added via CSS ::before)
 *  label         string   — small orange label e.g. "PARAM PUJYA" or "ANCIENT VEDIC"
 *  name          string   — bold attribution name e.g. "Shri Guruji"
 *  quoteSize     string   — text size, default 'text-xl md:text-3xl'
 *
 * Usage:
 *  <QuoteBlock
 *    quote="World belongs to humanity..."
 *    label="PARAM PUJYA"
 *    name="Shri Guruji"
 *  />
 */
const QuoteBlock = ({
  quote,
  label,
  name,
  quoteSize = 'text-xl md:text-3xl',
}) => (
  <div>
    <blockquote className={`${quoteSize} font-light text-gray-700 leading-relaxed mb-8 italic`}>
      "{quote}"
    </blockquote>
    {(label || name) && (
      <div className="text-right">
        {label && (
          <p className="text-orange-500 font-semibold text-base md:text-lg">{label}</p>
        )}
        {name && (
          <p className="text-xl md:text-2xl font-bold text-gray-800">{name}</p>
        )}
      </div>
    )}
  </div>
);

export default QuoteBlock;
